import React from 'react';
import { Analytics } from '@vercel/analytics/react';
import FinancialInsightsDashboard from './247payments-partner-presentation';
import './App.css';

function App() {
  return (
    <div className="App">
      <FinancialInsightsDashboard />
      <Analytics />
    </div>
  );
}

export default App;
